import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./RecursiveTextCardFragment.module.css";
import { CardFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/CardFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/LoadingCardFragment/LoadingCardFragment";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import {
  useFormatRecursiveSelfValue,
  type FormatStep,
} from "@coworker/apprestructured/src/task-management/hooks/useFormatRecursiveSelfValue";
import { type FieldFormat } from "@coworker/apprestructured/src/task-management/hooks/useFormatFieldValue";

// value is resolved from the task at render time — config only needs field + format
type ConfigStep = { field: string; format?: FieldFormat };

export type RecursiveTextCardFragmentConfigProps = {
  steps: ConfigStep[];
};

type RecursiveTextCardFragmentProps = {
  configProps: RecursiveTextCardFragmentConfigProps;
  commonProps: CardFragmentCommonProps;
};

function RecursiveTextCardFragment({
  configProps,
  commonProps,
}: RecursiveTextCardFragmentProps) {
  const { steps } = configProps;
  const { task } = commonProps;
  const formatRecursive = useFormatRecursiveSelfValue();

  if (!steps?.length) {
    return null;
  }

  const resolvedSteps = steps.map((step) => ({
    format: step.format,
    value: getTypedValue<string>(getByPath(task, step.field)) ?? step.field,
  }));

  if (resolvedSteps.some((s) => isLoading(s.value))) {
    return <LoadingCardFragment />;
  }

  const text = formatRecursive(resolvedSteps as FormatStep[]);

  if (!text) {
    return null;
  }

  return <FixaText className={styles["root"]}>{text}</FixaText>;
}

export default RecursiveTextCardFragment;
